// utils/handleCancelSubscription.js
import { doc, updateDoc, deleteField, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

export const handleCancelSubscription = async ({
     uid,
     setLoading,
     onDone,
     onError,
}) => {
     try {

          if (!uid) throw new Error("UID missing");
          const confirmed = window.confirm(
               "Are you sure you want to cancel? You will lose your benefits at the end of the current billing cycle."
          );
          if (!confirmed) return;

          setLoading?.(true);

          const userRef = doc(db, "users", uid);

          await updateDoc(userRef, {
               subscriptions: "cancel_user",
               planDetails: deleteField(),
               isPremium: false,

               // message (English)
               subscriptionMessage: "Your subscription has been cancelled successfully.",

               // optional tracking
               cancelledAt: serverTimestamp(),
               updatedAt: serverTimestamp(),
          });

          onDone?.();
          return { ok: true };
     } catch (err) {
          console.error("handleCancelSubscription error:", err);
          onError?.(err);
          return { ok: false, error: err?.message || "Cancel failed" };
     } finally {
          setLoading?.(false);
     }
};